<template>
  <div
    class="bg-white flex flex-col h-full"
    :class="{'panel--scrollable': scrollable}"
  >
    <div class="w-full text-gray-600 text-sm flex-shrink-0 border-b" v-if="!hideHeader">
      <div class="flex">
        <div class="flex-grow px-4 pt-4 mb-2">
          <slot name="panel__header"></slot>
        </div>
        <div class="z-10 p-4">
          <slot name="panel__actions"></slot>
        </div>
      </div>
      <div class="flex flex-between px-4 pb-4 -mt-2" v-if="!hideFilters">
        <div class="text-left w-full mt-2">
          <slot name="panel__filters"></slot>
        </div>
      </div>
    </div>
    <div class="panel__status">
      <slot name="panel__status"></slot>
    </div>
    <main
      class="scrollbar"
      :class="{'overflow-y-auto overflow-x-hidden max-h-full flex-grow': scrollable}"
      ref="panelBody"
    >
      <slot></slot>
    </main>
    <footer class="p-4 border-t border-gray-200" v-if="footer">
      <slot name="panel__footer"></slot>
    </footer>
  </div>
</template>

<script>
export default {
  props: {
    scrollable: Boolean,
    footer: Boolean,
    startBottom: Boolean,
    scrollWatcher: Date,
    hideHeader: {
      type: Boolean,
      default: false
    },
    hideFilters: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      needsToScroll: true
    }
  },

  methods: {
    maybeScrollToBottom() {
      if (this.startBottom && this.needsToScroll) {
        this.scrollToBottom()
        this.needsToScroll = false
      }
    },

    scrollToBottom() {
      var panelBody = this.$refs.panelBody
      var panelBodyHeight = panelBody.scrollHeight

      panelBody.scrollTop = panelBodyHeight
    }
  },

  updated: function () {
    this.$nextTick(this.maybeScrollToBottom())
  },

  mounted: function () {
    this.$nextTick(this.maybeScrollToBottom())
  },

  watch: {
    async scrollWatcher() {
      await this.$nextTick()
      this.$nextTick(this.scrollToBottom())
    }
  }
}
</script>
